import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getAllContact = () => {
  return httpClient.get(server.CONTACT + `/getAll`);
};

export const getAllContactLimit200 = () => {
  return httpClient.get(server.CONTACT + `/getAllLimit200`);
};

export const getAllContactPagination = (page, limit) => {
  return httpClient.get(server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
    },
  });
};

export const getAllContactPaginationByQuery = (
  page,
  limit,
  search,
  contact_type
) => {
  // console.log(`page = ${page}, limit = ${limit}, search = ${search}, contact_type = ${contact_type}`);

  return httpClient.get(server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
      search,
      contact_type,
    },
  });
};

export const getAllContactPaginationBySort = (
  page,
  limit,
  search,
  contact_type,
  sortBy,
  sortDesc
) => {
  // console.log(`page = ${page}, limit = ${limit}, search = ${search}, contact_type = ${contact_type}`);

  return httpClient.get(server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
      search,
      contact_type,
      sortBy,
      sortDesc,
    },
  });
};

export const getContactByContactType = (id) => {
  return httpClient.get(server.CONTACT + `/getByContact_type/${id}`);
};

export const createContact = (data) => {
  return httpClient.post(server.CONTACT, data);
};

export const updateContact = (id, data) => {
  return httpClient.put(server.CONTACT + `/${id}`, data);
};

export const deleteContact = (id) => {
  return httpClient.delete(server.CONTACT + `/${id}`);
};

export const getMasterContactSearch = (query) => {
  return httpClient.get(server.CONTACT + `/searchdata`, query);
};

export const getMasterContactCheckcontactid = (id) => {
  return httpClient.get(server.CONTACT + `/checkcontactid/${id}`);
};
